<div class="ct-overlay">
  <div class="ct-modal-pay">
    <div class="spinner">
      <app-spinner></app-spinner>
    </div>
    <a
      *ngIf="locale === 'ar-EG' && sessionsID && paymentId"
      #container
      href="{{ originUrl }}/assets/payment.html?sessionId={{
        sessionsID
      }}&orderId={{ paymentId }}&merchant_id={{merchantID}}"
      style="display: none"
    >{{"Payment Link"}}</a>

    <iframe
      *ngIf="locale !== 'ar-EG'"
      [srcdoc]="trustedHtmlContent"
      height="800"
      width="450"
      title=""
    ></iframe>

  </div>
</div>
